import { ErrorHandler, inject, Injectable } from '@angular/core';
import { AmplitudeCRMEventTypes } from '@pinnakl/shared/types';
import { AmplitudeEventsCollector } from '@pinnakl/shared/util-external-services';
import { getErrorObject } from '@pinnakl/shared/util-helpers';

const ERROR_THROTTLE_TIME_SECONDS = 60;
const UNTRACKED_ERROR_MESSAGES = ['ResizeObserver loop'];

@Injectable({
  providedIn: 'root',
})
export class PinnaklErrorHandler implements ErrorHandler {
  private readonly errorsMapDatetime = new Map<string, Date>();
  private readonly errorsMapCount = new Map<string, number>();

  private readonly amplitudeEventsCollector = inject(AmplitudeEventsCollector);

  handleError(error: any): void {
    console.error('[PinnaklErrorHandler] Error', error);
    if (!this.isTracked(error)) {
      return;
    }
    const message = error.message;
    const lastErrorDatetime = this.errorsMapDatetime.get(message);
    if (lastErrorDatetime) {
      if (Date.now() - lastErrorDatetime.getTime() > ERROR_THROTTLE_TIME_SECONDS * 1000) {
        this.amplitudeEventsCollector.track(AmplitudeCRMEventTypes.GlobalError, {
          sameErrorsInSessionCount: this.errorsMapCount.get(message) ?? 0,
          location: location.href,
          error: getErrorObject(error),
        });
      }
    } else {
      this.errorsMapDatetime.set(message, new Date());
      this.amplitudeEventsCollector.track(AmplitudeCRMEventTypes.GlobalError, {
        sameErrorsInSessionCount: this.errorsMapCount.get(message) ?? 0,
        location: location.href,
        error: getErrorObject(error),
      });
    }

    this.errorsMapCount.set(message, (this.errorsMapCount.get(message) ?? 0) + 1);
  }

  private isTracked(error: any): boolean {
    const message = error?.message;
    return !!error && !(typeof message === 'string' && UNTRACKED_ERROR_MESSAGES.some(text => message.includes(text)));
  }
}
